var formik = require('formik');

var patternflyReact = require('patternfly-react');

var React = require('react');
/**
 * Ensure that the input values match the property definitions
 */


function sanitizeValues(definition, initialValue) {
  return Object.keys(definition).reduce(function (result, key) {
    var obj;
    var prop = definition[key];
    var value = massageValue(prop, initialValue[key], prop.defaultValue);
    return Object.assign({}, result, (obj = {}, obj[key] = value, obj));
  }, {});
}
/**
 * Add the 'name' field from the property ID and sort them by the 'order' property
 */


function enrichAndOrderProperties(definition) {
  return Object.keys(definition).map(function (key) {
    return Object.assign({}, definition[key], {
      name: key,
      required: massageRequired(definition[key]),
      type: massageType(definition[key])
    });
  }).sort(function (a, b) {
    var aOrder = a.order || 0;
    var bOrder = b.order || 0;
    return aOrder - bOrder;
  });
}
/**
 * Converts various values passed into the property type to known input types
 *
 * @param property
 */


function massageType(property) {
  var type = property.type || 'text';

  switch (type) {
    case 'hidden':
      return type;

    case 'int':
    case 'integer':
    case 'long':
      type = 'number';
      break;

    case 'string':
      type = 'text';
      break;

    case 'boolean':
      type = 'checkbox';
  }

  if (typeof property.enum !== 'undefined' && property.enum.length) {
    type = 'select';
  }

  if (typeof property.secret === 'boolean' && property.secret) {
    type = 'password';
  }

  return type;
}
/**
 * Ensure that the 'required' property is false for checkboxes and hidden fields
 *
 * This is a candidate for removal in the future, as it's a workaround
 *
 * @param property
 */


function massageRequired(property) {
  switch (property.type) {
    case 'boolean':
    case 'checkbox':
    case 'hidden':
      return false;

    default:
      return property.required;
  }
}

function getNewArrayRow(definition) {
  return sanitizeValues(definition, {});
}

function getNewArrayRows(missing, definition) {
  var answer = [];

  for (var i = 0; i < missing; i++) {
    answer.push(getNewArrayRow(definition));
  }

  return answer;
}

function sanitizeInitialArrayValue(definition, value, minimum) {
  var sanitizedValue = (value || []).map(function (v) {
    return sanitizeValues(definition, v);
  });
  var available = sanitizedValue.length;
  var missing = (minimum || 0) - available;

  if (missing < 0) {
    return sanitizedValue;
  }

  return sanitizedValue.concat(getNewArrayRows(missing, definition));
}
/**
 * Converts the given value from a string to the type defined in the property definition
 *
 * This is a candidate for removal as it's a workaround
 *
 * @param property
 * @param value
 */


function massageValue(property, value, defaultValue) {
  switch (property.type) {
    case 'number':
      return parseInt(value || defaultValue || 0, 10);

    case 'boolean':
    case 'checkbox':
      return String(value || defaultValue || 'false').toLocaleLowerCase() === 'true';

    case 'array':
      var minElements = typeof property.arrayDefinitionOptions !== 'undefined' ? property.arrayDefinitionOptions.minElements : 0;
      return sanitizeInitialArrayValue(property.arrayDefinition || {}, value, minElements);

    default:
      // if the value has an enum property
      // a select control is used, default
      // to the first available value
      if (typeof value === 'undefined' && property.enum && property.enum.length > 0) {
        return defaultValue || property.enum[0].value || '';
      }

      return value || defaultValue || '';
  }
}

var AutoFormHelpBlock =
/*@__PURE__*/
function (superclass) {
  function AutoFormHelpBlock() {
    superclass.apply(this, arguments);
  }

  if (superclass) AutoFormHelpBlock.__proto__ = superclass;
  AutoFormHelpBlock.prototype = Object.create(superclass && superclass.prototype);
  AutoFormHelpBlock.prototype.constructor = AutoFormHelpBlock;

  AutoFormHelpBlock.prototype.render = function render() {
    return React.createElement(patternflyReact.HelpBlock, null, this.props.error || this.props.description || '');
  };

  return AutoFormHelpBlock;
}(React.Component);

function getValidationState(ref) {
  var form = ref.form;
  var field = ref.field;
  return form.touched[field.name] && form.errors[field.name] ? 'error' : form.touched[field.name] ? 'success' : null;
}
/**
 * Returns a valid DOM id from the given string
 * @param value
 */


function toValidHtmlId(value) {
  return value ? value.replace(/[^a-zA-Z0-9]+/g, '-').toLowerCase() : value || '';
}

var FormInputComponent = function FormInputComponent(props) {
  return React.createElement(patternflyReact.FormGroup, Object.assign({}, props.property.formGroupAttributes, {
    controlId: toValidHtmlId(props.field.name),
    validationState: getValidationState(props)
  }), props.property.displayName && React.createElement(patternflyReact.ControlLabel, Object.assign({
    className: props.property.required && !props.allFieldsRequired ? 'required-pf' : ''
  }, props.property.controlLabelAttributes), props.property.displayName), props.property.labelHint && React.createElement(patternflyReact.ControlLabel, null, React.createElement(patternflyReact.FieldLevelHelp, {
    content: props.property.labelHint
  })), React.createElement(patternflyReact.FormControl, Object.assign({}, props.property.fieldAttributes, props.field, {
    "data-testid": toValidHtmlId(props.field.name),
    disabled: props.form.isSubmitting || props.property.disabled,
    placeholder: props.property.placeholder,
    type: props.type || 'text',
    onChange: props.field.onChange,
    title: props.property.controlHint,
    list: toValidHtmlId(props.field.name) + "-list"
  })), props.property.dataList && props.property.dataList.length > 0 && React.createElement("datalist", {
    id: toValidHtmlId(props.field.name) + "-list"
  }, props.property.dataList.map(function (opt, index) {
    return React.createElement("option", {
      key: index,
      value: opt
    }, opt);
  })), React.createElement(AutoFormHelpBlock, {
    error: props.form.errors[props.field.name],
    description: props.property.description
  }));
};

function objectWithoutProperties(obj, exclude) {
  var target = {};

  for (var k in obj) {
    if (Object.prototype.hasOwnProperty.call(obj, k) && exclude.indexOf(k) === -1) target[k] = obj[k];
  }

  return target;
}

function getSelectedValues(select) {
  return Array.from(select.selectedOptions).map(function (option) {
    return option.value;
  });
}

var FormSelectComponent = function FormSelectComponent(props) {
  var isMultiple = props.property.fieldAttributes && props.property.fieldAttributes.multiple;
  var ref = props.field;
  var onChange = ref.onChange;
  var rest = objectWithoutProperties(ref, ["onChange", "onBlur"]);
  var field = rest;

  var handleChange = function handleChange(event) {
    if (isMultiple) {
      var newValue = getSelectedValues(event.currentTarget);
      props.form.setFieldValue(props.field.name, newValue);
    } else {
      onChange(event);
    }
  };

  return React.createElement(patternflyReact.FormGroup, Object.assign({}, props.property.formGroupAttributes, {
    controlId: toValidHtmlId(field.name),
    validationState: getValidationState(props)
  }), props.property.displayName && React.createElement(patternflyReact.ControlLabel, Object.assign({
    className: props.property.required && !props.allFieldsRequired ? 'required-pf' : ''
  }, props.property.controlLabelAttributes), props.property.displayName), props.property.labelHint && React.createElement(patternflyReact.ControlLabel, null, React.createElement(patternflyReact.FieldLevelHelp, {
    content: props.property.labelHint
  })), React.createElement(patternflyReact.FormControl, Object.assign({
    size: isMultiple ? 12 : undefined
  }, props.property.fieldAttributes, props.field, {
    onChange: handleChange,
    onBlur: handleChange,
    "data-testid": toValidHtmlId(props.field.name),
    disabled: props.form.isSubmitting || props.property.disabled,
    componentClass: "select",
    title: props.property.controlHint
  }), (props.property.enum || []).map(function (opt, index) {
    return React.createElement("option", {
      key: index + "-" + opt.label,
      value: opt.value
    }, opt.label);
  })), React.createElement(AutoFormHelpBlock, {
    error: props.form.errors[props.field.name],
    description: props.property.description
  }));
};

var FormTextAreaComponent = function FormTextAreaComponent(props) {
  return React.createElement(patternflyReact.FormGroup, Object.assign({}, props.property.formGroupAttributes, {
    controlId: toValidHtmlId(props.field.name),
    validationState: getValidationState(props)
  }), props.property.displayName && React.createElement(patternflyReact.ControlLabel, {
    className: props.property.required && !props.allFieldsRequired ? 'required-pf' : ''
  }, props.property.displayName), props.property.labelHint && React.createElement(patternflyReact.ControlLabel, null, React.createElement(patternflyReact.FieldLevelHelp, {
    content: props.property.labelHint
  })), React.createElement(patternflyReact.FormControl, Object.assign({}, props.property.fieldAttributes, props.field, {
    "data-testid": toValidHtmlId(props.field.name),
    disabled: props.form.isSubmitting || props.property.disabled,
    componentClass: "textarea",
    title: props.property.controlHint
  })), React.createElement(AutoFormHelpBlock, {
    error: props.form.errors[props.field.name],
    description: props.property.description
  }));
};

var FormCheckboxComponent = function FormCheckboxComponent(props) {
  return React.createElement(patternflyReact.FormGroup, Object.assign({}, props.property.formGroupAttributes, {
    controlId: toValidHtmlId(props.field.name),
    validationState: getValidationState(props)
  }), React.createElement(patternflyReact.Checkbox, Object.assign({}, props.property.fieldAttributes, props.field, {
    checked: props.field.value,
    "data-testid": toValidHtmlId(props.field.name),
    disabled: props.form.isSubmitting || props.property.disabled,
    title: props.property.controlHint
  }), props.property.displayName, props.property.labelHint && React.createElement(patternflyReact.FieldLevelHelp, {
    className: 'inline-block',
    content: props.property.labelHint
  })), React.createElement(AutoFormHelpBlock, {
    error: props.form.errors[props.field.name],
    description: props.property.description
  }));
};

var FormHiddenComponent = function FormHiddenComponent(props) {
  return React.createElement("div", Object.assign({}, props.property.formGroupAttributes), React.createElement("input", Object.assign({}, props.property.fieldAttributes, props.field, {
    type: props.type,
    id: toValidHtmlId(props.field.name),
    "data-testid": toValidHtmlId(props.field.name)
  })), props.form.touched[props.field.name] && props.form.errors[props.field.name] && React.createElement("div", {
    className: "error"
  }, props.form.errors[props.field.name]));
};

var durations = [{
  label: 'Milliseconds',
  value: 1
}, {
  label: 'Seconds',
  value: 1000
}, {
  label: 'Minutes',
  value: 60000
}, {
  label: 'Hours',
  value: 3600000
}, {
  label: 'Days',
  value: 86400000
}];

function calculateDuration(duration, initialValue) {
  return initialValue / duration.value;
}

function calculateValue(duration, value) {
  return value * duration.value;
}

var FormDurationComponent =
/*@__PURE__*/
function (superclass) {
  function FormDurationComponent(props) {
    var this$1 = this;
    superclass.call(this, props);
    this.inputField = undefined; // find the highest duration that keeps the duration above 1

    var index = durations.findIndex(function (d) {
      return !(this$1.props.field.value / d.value >= 1.0);
    }) - 1; // if the index is invalid than we use the highest available duration.

    var duration = durations[index] || durations[durations.length - 1];
    this.state = {
      duration: duration
    };
    this.handleOnSelect = this.handleOnSelect.bind(this);
    this.handleChange = this.handleChange.bind(this);
    this.handleBlur = this.handleBlur.bind(this);
    this.receiveInputRef = this.receiveInputRef.bind(this);
  }

  if (superclass) FormDurationComponent.__proto__ = superclass;
  FormDurationComponent.prototype = Object.create(superclass && superclass.prototype);
  FormDurationComponent.prototype.constructor = FormDurationComponent;

  FormDurationComponent.prototype.receiveInputRef = function receiveInputRef(ref) {
    this.inputField = ref;
  };

  FormDurationComponent.prototype.handleOnSelect = function handleOnSelect(eventKey, event) {
    var newDuration = durations.find(function (duration) {
      return duration.value === eventKey;
    }) || durations[0];
    this.setState({
      duration: newDuration
    });
    this.props.form.setFieldValue(this.props.field.name, calculateValue(newDuration, this.inputField.valueAsNumber), true);
  };

  FormDurationComponent.prototype.handleChange = function handleChange(event) {
    this.props.form.setFieldValue(this.props.field.name, calculateValue(this.state.duration, event.target.valueAsNumber), true);
  };

  FormDurationComponent.prototype.handleBlur = function handleBlur(event) {
    this.props.form.setFieldValue(this.props.field.name, calculateValue(this.state.duration, event.target.valueAsNumber), true);
  };

  FormDurationComponent.prototype.render = function render() {
    var controlId = toValidHtmlId(this.props.field.name) + "-duration";
    return React.createElement(patternflyReact.FormGroup, Object.assign({}, this.props.property.formGroupAttributes, {
      controlId: toValidHtmlId(this.props.field.name),
      validationState: getValidationState(this.props)
    }), React.createElement(patternflyReact.ControlLabel, Object.assign({
      className: this.props.property.required && !this.props.allFieldsRequired ? 'required-pf' : ''
    }, this.props.property.controlLabelAttributes), this.props.property.displayName), this.props.property.labelHint && React.createElement(patternflyReact.ControlLabel, null, React.createElement(patternflyReact.FieldLevelHelp, {
      content: this.props.property.labelHint
    })), React.createElement(patternflyReact.Form.InputGroup, null, React.createElement(patternflyReact.Form.FormControl, Object.assign({
      min: 0
    }, this.props.property.fieldAttributes, {
      "data-testid": toValidHtmlId(this.props.field.name),
      type: 'number',
      defaultValue: calculateDuration(this.state.duration, this.props.field.value),
      disabled: this.props.form.isSubmitting || this.props.property.disabled,
      onChange: this.handleChange,
      onBlur: this.handleBlur,
      inputRef: this.receiveInputRef,
      title: this.props.property.controlHint
    })), React.createElement(patternflyReact.DropdownButton, {
      id: controlId,
      "data-testid": controlId,
      componentClass: patternflyReact.Form.InputGroup.Button,
      title: this.state.duration.label,
      onSelect: this.handleOnSelect,
      disabled: this.props.form.isSubmitting || this.props.property.disabled
    }, durations.map(function (duration, index) {
      return React.createElement(patternflyReact.MenuItem, {
        key: index,
        eventKey: duration.value
      }, duration.label);
    }))), React.createElement(AutoFormHelpBlock, {
      error: this.props.form.errors[this.props.field.name],
      description: this.props.property.description
    }));
  };

  return FormDurationComponent;
}(React.Component);

var TextButton =
/*@__PURE__*/
function (superclass) {
  function TextButton() {
    superclass.apply(this, arguments);
  }

  if (superclass) TextButton.__proto__ = superclass;
  TextButton.prototype = Object.create(superclass && superclass.prototype);
  TextButton.prototype.constructor = TextButton;

  TextButton.prototype.render = function render() {
    var enable = typeof this.props.enable !== 'undefined' ? this.props.enable : true;
    return React.createElement(React.Fragment, null, this.props.linkText ? React.createElement("button", {
      type: "button",
      onClick: this.props.onClick,
      className: "btn btn-link",
      dangerouslySetInnerHTML: {
        __html: this.props.linkText
      },
      disabled: !enable
    }) : React.createElement("button", {
      type: "button",
      onClick: this.props.onClick,
      className: "btn btn-link",
      disabled: !enable
    }, this.props.children && this.props.children));
  };

  return TextButton;
}(React.Component);

var FormArrayComponent =
/*@__PURE__*/
function (superclass) {
  function FormArrayComponent() {
    superclass.apply(this, arguments);
  }

  if (superclass) FormArrayComponent.__proto__ = superclass;
  FormArrayComponent.prototype = Object.create(superclass && superclass.prototype);
  FormArrayComponent.prototype.constructor = FormArrayComponent;

  FormArrayComponent.prototype.render = function render() {
    var this$1 = this;

    if (typeof this.props.property.arrayDefinition === 'undefined') {
      return React.createElement("div", {
        className: "alert alert-warning"
      }, React.createElement("span", null, "No Array definition supplied for array type"));
    }

    var definition = this.props.property.arrayDefinition;
    var options = this.props.property.arrayDefinitionOptions || {};
    var formGroupAttributes = options.formGroupAttributes || {};
    var fieldAttributes = options.fieldAttributes || {};
    var controlLabelAttributes = options.controlLabelAttributes || {};
    var arrayControlAttributes = options.arrayControlAttributes || {};
    var arrayRowTitleAttributes = options.arrayRowTitleAttributes || {};
    var minElements = options.minElements || 0;
    var values = this.props.form.values[this.props.name] || [];
    return React.createElement(React.Fragment, null, values.map(function (value, index) {
      var fieldName = this$1.props.name + "[" + index + "]";
      return React.createElement(FormBuilder, {
        key: fieldName,
        definition: definition,
        initialValue: value,
        customComponents: this$1.props.customComponents,
        i18nRequiredProperty: ''
      }, function (ref) {
        var rowValue = ref.initialValue;
        var propertiesArray = ref.propertiesArray;
        var getField = ref.getField;
        var titleKey = fieldName + "-title";
        var controlGroupName = fieldName + "-array-controls";
        return React.createElement("fieldset", null, options.rowTitle && React.createElement("div", Object.assign({
          key: titleKey
        }, arrayRowTitleAttributes), React.createElement("h5", {
          className: "form-array-control__row-title"
        }, React.createElement("strong", null, index + 1 + ". " + options.rowTitle))), propertiesArray.map(function (property) {
          return getField({
            allFieldsRequired: this$1.props.allFieldsRequired || false,
            key: fieldName + "." + property.name,
            name: fieldName + "." + property.name,
            property: Object.assign({}, {
              controlLabelAttributes: controlLabelAttributes,
              fieldAttributes: fieldAttributes,
              formGroupAttributes: formGroupAttributes
            }, property),
            value: rowValue[property.name]
          });
        }), React.createElement("div", Object.assign({
          key: controlGroupName
        }, formGroupAttributes, arrayControlAttributes), React.createElement("label", Object.assign({
          htmlFor: toValidHtmlId(controlGroupName + "-control"),
          className: "control-label"
        }, controlLabelAttributes), "\xA0"), React.createElement("div", {
          id: toValidHtmlId(controlGroupName + "-control")
        }, React.createElement("div", {
          className: "form-array-control__array-controls"
        }, options.showSortControls && React.createElement(React.Fragment, null, React.createElement(TextButton, {
          onClick: function onClick() {
            this$1.props.move(index, index - 1);
          },
          enable: index > 0
        }, React.createElement("i", {
          className: "fa fa-arrow-circle-o-up"
        })), React.createElement(TextButton, {
          onClick: function onClick() {
            this$1.props.move(index, index + 1);
          },
          enable: index < values.length - 1
        }, React.createElement("i", {
          className: "fa fa-arrow-circle-o-down"
        }))), React.createElement(TextButton, {
          onClick: function onClick() {
            return this$1.props.remove(index);
          },
          enable: values.length > minElements
        }, React.createElement("i", {
          className: "fa fa-trash-o"
        }))), React.createElement("div", {
          className: "help-block"
        }, "\xA0"))));
      });
    }), React.createElement(TextButton, {
      onClick: function onClick() {
        return this$1.props.push(getNewArrayRow(definition));
      }
    }, options.i18nAddElementText || '+ Add Another'));
  };

  return FormArrayComponent;
}(React.Component);

var FormBuilder =
/*@__PURE__*/
function (superclass) {
  function FormBuilder() {
    var this$1 = this;
    superclass.apply(this, arguments);
    /**
     * Converts a property configuration to some kind of input field
     * @param props
     */

    this.getField = function (props) {
      // Massage the value in the definition to an input type
      var type = massageType(props.property);
      var componentTypemaps = Object.assign({}, {
        checkbox: FormCheckboxComponent,
        duration: FormDurationComponent,
        hidden: FormHiddenComponent,
        select: FormSelectComponent,
        textarea: FormTextAreaComponent
      }, this$1.props.customComponents || {});

      switch (type) {
        case 'array':
          return React.createElement(formik.FieldArray, Object.assign({}, props, {
            key: props.property.name,
            name: props.property.name
          }), function (fieldArrayProps) {
            return React.createElement(FormArrayComponent, Object.assign({}, props, fieldArrayProps, {
              customComponents: this$1.props.customComponents
            }));
          });

        default:
          return React.createElement(formik.Field, Object.assign({
            key: props.property.name,
            name: props.property.name,
            type: type
          }, props, {
            component: componentTypemaps[type] || FormInputComponent
          }));
      }
    };
  }

  if (superclass) FormBuilder.__proto__ = superclass;
  FormBuilder.prototype = Object.create(superclass && superclass.prototype);
  FormBuilder.prototype.constructor = FormBuilder;

  FormBuilder.prototype.render = function render() {
    var propertiesArray = enrichAndOrderProperties(this.props.definition);
    var massagedValue = sanitizeValues(this.props.definition, this.props.initialValue);
    return this.props.children({
      getField: this.getField,
      initialValue: massagedValue,
      propertiesArray: propertiesArray
    });
  };

  return FormBuilder;
}(React.Component);

function objectWithoutProperties$1(obj, exclude) {
  var target = {};

  for (var k in obj) {
    if (Object.prototype.hasOwnProperty.call(obj, k) && exclude.indexOf(k) === -1) target[k] = obj[k];
  }

  return target;
}

var AutoForm =
/*@__PURE__*/
function (superclass) {
  function AutoForm(props) {
    superclass.call(this, props);
  }

  if (superclass) AutoForm.__proto__ = superclass;
  AutoForm.prototype = Object.create(superclass && superclass.prototype);
  AutoForm.prototype.constructor = AutoForm;

  AutoForm.prototype.handleSave = function handleSave(value, formikBag) {
    if (typeof this.props.onSave === 'function') {
      this.props.onSave(value, formikBag);
    }
  };

  AutoForm.prototype.render = function render() {
    var this$1 = this;
    return React.createElement(FormBuilder, {
      definition: this.props.definition,
      initialValue: this.props.initialValue || {},
      customComponents: this.props.customComponents || {},
      i18nRequiredProperty: this.props.i18nRequiredProperty
    }, function (ref) {
      var initialValue = ref.initialValue;
      var propertiesArray = ref.propertiesArray;
      var getField = ref.getField;
      var isInitialValid = typeof this$1.props.validateInitial === 'function' ? Object.keys(this$1.props.validateInitial(initialValue) || {}).length === 0 : this$1.props.isInitialValid || false;
      return React.createElement(formik.Formik, {
        initialValues: initialValue,
        onSubmit: this$1.props.onSave || function () {
          /* todo right now silently ignore */
        },
        isInitialValid: isInitialValid,
        validate: this$1.props.validate
      }, function (ref) {
        var values = ref.values;
        var dirty = ref.dirty;
        var errors = ref.errors;
        var rest$1 = objectWithoutProperties$1(ref, ["values", "touched", "dirty", "errors"]);
        var rest = rest$1;
        var propertyComponents = propertiesArray.map(function (property) {
          var obj;
          var err = typeof errors === 'object' ? errors : (obj = {}, obj[property.name] = errors, obj);
          return getField(Object.assign({}, {
            allFieldsRequired: this$1.props.allFieldsRequired || false,
            errors: err,
            property: property,
            value: (values || {})[property.name]
          }, rest));
        });
        return this$1.props.children(Object.assign({}, {
          dirty: dirty,
          errors: errors,
          fields: React.createElement(React.Fragment, null, this$1.props.i18nFieldsStatusText && React.createElement("p", {
            className: "fields-status-pf",
            dangerouslySetInnerHTML: {
              __html: this$1.props.i18nFieldsStatusText
            }
          }), propertyComponents),
          fieldsAsArray: propertyComponents,
          values: values
        }, rest));
      });
    });
  };

  return AutoForm;
}(React.Component);

exports.AutoForm = AutoForm;
exports.AutoFormHelpBlock = AutoFormHelpBlock;
exports.FormInputComponent = FormInputComponent;
exports.FormSelectComponent = FormSelectComponent;
exports.FormTextAreaComponent = FormTextAreaComponent;
exports.FormCheckboxComponent = FormCheckboxComponent;
exports.FormHiddenComponent = FormHiddenComponent;
exports.FormDurationComponent = FormDurationComponent;
exports.TextButton = TextButton;
exports.getValidationState = getValidationState;
exports.toValidHtmlId = toValidHtmlId;